// Состояние websocket-соединения: по нему полоса «Нет связи» решает, показываться ли
const state = {
  connected: true,
  disconnectedSince: null,
}

const mutations = {
  setConnected (state, connected) {
    // Повторный disconnect во время бэкоффа не должен сдвигать момент разрыва
    if (state.connected === connected) {
      return
    }

    state.connected = connected
    state.disconnectedSince = connected ? null : Date.now()
  },
}

export default {
  namespaced: true,
  state,
  mutations,
}
